import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { RouterStateEssentials } from './model/router-state-essentials';

@Injectable({
  providedIn: 'root'
})
export class RouterStateUtilityService {
  getRouterStateEssentialsFromChilds(state: RouterStateSnapshot): RouterStateEssentials {
    let child = state.root;
    const urlSegments = [...child.url];
    while (child.firstChild) {
      child = child.firstChild;
      urlSegments.push(...child.url);
    }
    return { data: child.data, paramMap: child.paramMap, queryParamMap: child.queryParamMap, url: urlSegments };
  }
}
